import { useState, useCallback } from 'react';
import {
  LiveKitRoom,
  RoomAudioRenderer,
} from '@livekit/components-react';
import '@livekit/components-styles';
import { VideoCallGrid } from './VideoCallGrid';
import { VideoCallControls } from './VideoCallControls';
import { ChatPanel } from './ChatPanel';
import { TranscriptionPanel } from './TranscriptionPanel';
import { useVideoCallStore } from '../../stores/videoCallStore';
import './VideoCall.css';

interface VideoCallRoomProps {
  token: string;
  serverUrl: string;
  onLeave?: () => void;
  isGuest?: boolean;
}

export function VideoCallRoom({ token, serverUrl, onLeave, isGuest = false }: VideoCallRoomProps) {
  const [showChat, setShowChat] = useState(false);
  const [showTranscription, setShowTranscription] = useState(false);
  const leaveRoom = useVideoCallStore((s) => s.leaveRoom);

  const handleDisconnected = useCallback(() => {
    leaveRoom();
    onLeave?.();
  }, [leaveRoom, onLeave]);

  return (
    <LiveKitRoom
      token={token}
      serverUrl={serverUrl}
      connect={true}
      video={true}
      audio={true}
      onDisconnected={handleDisconnected}
      data-lk-theme="default"
      className="videocall-room"
    >
      <RoomAudioRenderer />
      <VideoCallGrid />
      {showTranscription && <TranscriptionPanel />}
      {showChat && <ChatPanel />}
      <VideoCallControls
        onLeave={handleDisconnected}
        onToggleChat={() => setShowChat(!showChat)}
        onToggleTranscription={() => setShowTranscription(!showTranscription)}
        showRecordButton={!isGuest}
      />
    </LiveKitRoom>
  );
}
